import Resumo from './resumo';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import {
  postObjCadastroResumoAction,
  handleChangeCheckBox1,
  handleChangeCheckBox2
} from '../../store/resumo/actions';

import {
  getListRendaMensalAction,
  getListPatrimonioAction
} from '../../store/rendaPatrimonio/actions';

import {
  getListDeclaracaoAnualAction,
} from '../../store/declaracaoEspecifica/actions';

const mapStateToProps = (state) =>{
  let newProps = {
    ...state.tipoCadastroReducer,
    ...state.dadosIniciaisPFReducer,
    ...state.dadosIniciaisPJReducer,
    ...state.enderecoReducer,
    ...state.dadosComplementaresReducer,
    ...state.declaracaoEspecificaReducer,
    ...state.maisDetalhesReducer,
    ...state.documentosAnexosReducer,
    ...state.dadosBancarioReducer,
    navigation: state.navegationStepsReducer,
    conclusao: state.conclusaoReducer,
    resumo: state.resumoReducer,
    ddi: state.ddiReducer
  };

  if(state.dadosIniciaisPFReducer && state.dadosIniciaisPFReducer.formPF){
    newProps = { ...newProps, ...state.dadosIniciaisPFReducer.formPF};
  }
  if(state.dadosIniciaisPJReducer && state.dadosIniciaisPJReducer.formPJ){
    newProps = { ...newProps, ...state.dadosIniciaisPJReducer.formPJ};
  }
  if(state.enderecoReducer && state.enderecoReducer.formEndereco){
    newProps = { ...newProps, ...state.enderecoReducer.formEndereco};
  }
  if(state.dadosComplementaresReducer && state.dadosComplementaresReducer.formDados){
    newProps = { ...newProps, ...state.dadosComplementaresReducer.formDados};
  }
  if(state.declaracaoEspecificaReducer && state.declaracaoEspecificaReducer.formDeclaracaoPF){
    newProps = { ...newProps, ...state.declaracaoEspecificaReducer.formDeclaracaoPF};
  }
  if(state.declaracaoEspecificaReducer && state.declaracaoEspecificaReducer.formDeclaracaoPJ){
    newProps = { ...newProps, ...state.declaracaoEspecificaReducer.formDeclaracaoPJ};
  }
  if(state.maisDetalhesReducer && state.maisDetalhesReducer.formMaisDetalhes){
    newProps = { ...newProps, ...state.maisDetalhesReducer.formMaisDetalhes};
  }
  if(state.tipoCadastroReducer && state.tipoCadastroReducer.tipoContrato){
    newProps.tipoCadastro = state.tipoCadastroReducer;
  }

  if(state.dadosBancarioReducer && state.dadosBancarioReducer.formDadosBancarios){
    newProps.dadosBancario = state.dadosBancarioReducer;
  }

  switch (state.tipoCadastroReducer.tipoPessoaValue) {
    case "PessoaFisica": 
      newProps.dadosIniciais_codigoGerente = state.dadosIniciaisPFReducer.formPF.dadosIniciais_codigoGerente; 
      newProps.dadosIniciais_nomeGerente = state.dadosIniciaisPFReducer.formPF.dadosIniciais_nomeGerente;
      break;
    case "PessoaJuridica": 
      newProps.dadosIniciais_codigoGerente = state.dadosIniciaisPJReducer.formPJ.dadosIniciais_codigoGerente; 
      newProps.dadosIniciais_nomeGerente = state.dadosIniciaisPJReducer.formPJ.dadosIniciais_nomeGerente;
      break;
    default:
  }

  newProps.rendaPatrimonio = state.rendaPatrimonioReducer;
  newProps.declaracaoEspecifica = state.declaracaoEspecificaReducer;

  return newProps;
}

const mapDispatchToProps = dispatch =>
  bindActionCreators({
    postObjCadastroResumoAction,
    handleChangeCheckBox1,
    handleChangeCheckBox2,
    getListRendaMensalAction,
    getListPatrimonioAction,
    getListDeclaracaoAnualAction,
  }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Resumo);